import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import {
  defaultTimezone,
  formatToLocaleDateString,
  SupportedTimezone,
} from '@shared/services/datetime/datetime.utils';

@Injectable({ providedIn: 'root' })
export class DateTimeService {
  private readonly _timezone$ = new BehaviorSubject<SupportedTimezone>(defaultTimezone);

  public readonly timezone$ = this._timezone$.asObservable();

  public get timezone() {
    return this._timezone$.value;
  }

  public setTimezone(value: SupportedTimezone) {
    this._timezone$.next(value);
  }

  public formatLocaleDate$ = (value: string | number | undefined, format = 'medium') =>
    this.timezone$.pipe(
      map(timezone => formatToLocaleDateString(value, timezone, format)),
    );
}
